const DisabledCircle = () => {
  return (
    <svg
      width="129"
      height="129"
      viewBox="0 0 129 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <g clipPath="url(#clip0_2214_1277)">
          <rect width="129" height="129" rx="64.5" fill="#CDCDCD" />
          <line
            x1="29.519"
            y1="31.6582"
            x2="95.3844"
            y2="85.8599"
            stroke="#AFAFAF"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </g>
        <rect
          x="0.04"
          y="0.04"
          width="128.92"
          height="128.92"
          rx="64.46"
          stroke="#BEBDBD"
          strokeWidth="0.08"
        />
      </g>
      <defs>
        <clipPath id="clip0_2214_1277">
          <rect width="129" height="129" rx="64.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DisabledCircle
